import { useEffect, useState } from 'react';

/**
 * Lookup city & state from 6-digit India PIN via postalpincode.in (public API).
 */
export function useIndiaPincodeLookup(pincode) {
  const [state, setState] = useState({
    status: 'idle',
    city: '',
    stateName: '',
    locality: '',
    message: '',
  });

  useEffect(() => {
    const pin = String(pincode || '').replace(/\D/g, '');
    if (pin.length !== 6) {
      setState({ status: 'idle', city: '', stateName: '', locality: '', message: '' });
      return undefined;
    }

    let cancelled = false;
    setState((prev) => ({ ...prev, status: 'loading', message: '' }));

    const timer = window.setTimeout(() => {
      fetch(`https://api.postalpincode.in/pincode/${pin}`)
        .then((r) => r.json())
        .then((data) => {
          if (cancelled) return;
          const block = Array.isArray(data) ? data[0] : null;
          if (!block || block.Status !== 'Success' || !Array.isArray(block.PostOffice) || block.PostOffice.length === 0) {
            setState({
              status: 'error',
              city: '',
              stateName: '',
              locality: '',
              message: 'We could not find this PIN. Please choose your state and enter your city.',
            });
            return;
          }
          const po = block.PostOffice[0];
          setState({
            status: 'ok',
            city: String(po.District || po.Name || '').trim(),
            stateName: String(po.State || '').trim(),
            locality: String(po.Name || '').trim(),
            message: '',
          });
        })
        .catch(() => {
          if (cancelled) return;
          setState({
            status: 'error',
            city: '',
            stateName: '',
            locality: '',
            message: 'PIN lookup is unavailable. Please enter city and state manually.',
          });
        });
    }, 400);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [pincode]);

  return state;
}
